//@flow
import { TextButton } from 'texkit/dist/components/Buttons';

// Vendors
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// Helpers
import { publicURL } from '../../../../lib/helpers';
import classnames from 'classnames';

// Components
import { Modal } from '../../modals';
import { Trans } from '../../';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';

// Actions
import { closeModal } from '../../../../reducers/modal/modalActions';

// Styles
import './license-details-modal.scss';

const LicenseDetailsModal = ({
  modalName = 'LicenseDetailsModal',
  modalClassName,
  titleFile = 'Modals',
  titleId = 'FindYourID',
  titleFallback = 'Find your ID and DD/Audit numbers.',
  imageBaseName = 'dl-example',
  showDLNumber = true,
  showAuditNumber = true,
}) => {
  const [isVertical, setIsVertical] = useState(false);
  const dispatch = useDispatch();

  return (
    <Modal
      name={modalName}
      className={classnames('license-details-modal', modalClassName, {
        'vertical-card': isVertical,
      })}
      disableOnClickOutside={true} // DFCT0037036 - Disable closing modal on outside click to prevent accidental closure when users are trying to toggle between card views
      onOpen={() => setIsVertical(false)}
    >
      <h2 className="h1 modal-title">
        <Trans file={titleFile} id={titleId} fallback={titleFallback} />
      </h2>
      {/* DFCT0037036 - Changes to align modal content*/}
      <div
        className={classnames('modal-content', { 'vertical-view': isVertical })}
      >
        {showDLNumber && (
          <div className="description dl-number">
            <Trans
              file="Modals"
              id="LicenseOrIDNumber"
              fallback="Driver License or ID number"
            />
          </div>
        )}
        <div className="modal-graphic">
          <img
            className={classnames({ horizontal: !isVertical })}
            src={publicURL(
              `${imageBaseName}${isVertical ? '-vertical' : ''}.png`
            )}
            alt={<Trans file="Modals" id="LicenseDetailsImageAlt" />}
          />
        </div>
        {showAuditNumber && (
          <div className="description audit-number">
            <Trans file="Modals" id="AuditNumber" />
          </div>
        )}
        <div className="toggle-card-display">
          <TextButton type="button" onClick={() => setIsVertical(!isVertical)}>
            <Trans
              file="Labels"
              id={isVertical ? 'ShowHorizontalCard' : 'ShowVerticalCard'}
            />
          </TextButton>
        </div>
        <ButtonPrimary
          className="modal-close-button"
          onClick={() => dispatch(closeModal(modalName))}
        >
          <Trans file="Labels" id="gotIt" />
        </ButtonPrimary>
      </div>
    </Modal>
  );
};

LicenseDetailsModal.propTypes = {
  modalName: PropTypes.string,
  modalClassName: PropTypes.string,
  titleFile: PropTypes.string,
  titleId: PropTypes.string,
  titleFallback: PropTypes.string,
  imageBaseName: PropTypes.string,
  showDLNumber: PropTypes.bool,
  showAuditNumber: PropTypes.bool,
};

export default LicenseDetailsModal;
